import React from "react";
import CustomCheckBox from "./CustomCheckBox";
import "./MetricCategoryTreeView.css";
import "./GroupCategorytreeView.scss";

const GroupCategoryTreeView = ({
  groupData,
  subgroupData,
  setGroupData,
  setSubgroupData,
  title,
  checkedGroupIds,
  setGroupCheckedIds,
  checkedSubgroupIds,
  setSubgroupCheckedIds,
  expandedIds,
  setExpandIds,
  rule_view,
  isMetrics,
  setCheckedIds,
  setTreeData,
  treeData,
}) => {
  const setExpandedSegments = id => {
    setExpandIds(id);
  };

  const disableTreeItems = (nodes, allowedIds) => {
    return nodes.map(node => {
      // Check if current node's id is in allowedIds
      const isAllowed = allowedIds.includes(node.id);

      // Recursively process children
      const updatedChildren = disableTreeItems(node.children || [], allowedIds);

      return {
        ...node,
        is_disable: !isAllowed,
        children: updatedChildren,
      };
    });
  };

  const handleGroupChecked = checked => {
    // Ensure only the latest clicked ID is kept // allow only one selection
    const latestChecked = checked[checked.length - 1];
    setGroupCheckedIds([latestChecked]); // allow only one selection

    setSubgroupCheckedIds([]);

    setCheckedIds([]);
    setExpandIds([]);
  };

  const handleSubgroupChecked = checked => {
    if (checked.length === 0) {
      setSubgroupCheckedIds([]);
      setCheckedIds([]);
      setExpandIds([]);
      return;
    }

    // Ensure only the latest clicked ID is kept
    const latestChecked = checked[checked.length - 1];
    setSubgroupCheckedIds([latestChecked]);

    const matchedSubgroup = filteredSubGroupData.find(subgroup => subgroup.id === latestChecked);

    if (matchedSubgroup) {
      const lobIds = matchedSubgroup.lob_ids;
      setCheckedIds(lobIds);
      setExpandIds(lobIds);
      setTreeData(disableTreeItems(treeData, lobIds));
    } else {
      setCheckedIds([]);
      setExpandIds([]);
    }
  };

  const filteredSubGroupData = subgroupData.filter(sg => checkedGroupIds.includes(sg.group_id));

  return (
    <div
      className="group-container"
      style={{
        minWidth: rule_view ? "15%" : "18.5%",
        maxWidth: rule_view ? "15%" : "18.5%",
        borderBottom: rule_view ? "none" : undefined,
        borderRadius: rule_view ? "none" : "5px",
      }}
    >
      <div className="tree-view-header">
        <span className="title">
          {rule_view ? "Selected " : "Select "} {title}
        </span>
      </div>

      <div className="segments-tree" style={{ maxHeight: "59.5vh", minHeight: "59.5vh" }}>
        <div className="group-section">
          <div className="section-group-header">
            <span className="section-title">Group</span>
          </div>
          <div className="section-group-1">
            <div className="segments-tree custom-checkbox-tree">
              <CustomCheckBox
                nodes={groupData}
                checked={checkedGroupIds}
                expanded={expandedIds}
                onCheck={checked => handleGroupChecked(checked)}
                showArrow={false}
                handleButtonClick={() => {}}
                onExpand={expanded => setExpandedSegments(expanded)}
                key={title}
                disabled={rule_view}
                rule_view={rule_view}
                title={title}
                isMetrics={isMetrics}
              />
            </div>
          </div>
        </div>

        <div className="subgroup-section">
          <div className="section-group-header">
            <span className="section-title">Sub-Group</span>
          </div>
          <div className="section-group-2">
            <div className="segments-tree custom-checkbox-tree">
              {checkedGroupIds?.length > 0 ? (
                <CustomCheckBox
                  nodes={filteredSubGroupData}
                  checked={checkedSubgroupIds}
                  expanded={expandedIds}
                  onCheck={checked => handleSubgroupChecked(checked)}
                  showArrow={false}
                  handleButtonClick={() => {}}
                  onExpand={expanded => setExpandedSegments(expanded)}
                  key={title}
                  disabled={rule_view}
                  rule_view={rule_view}
                  title={title}
                  isMetrics={isMetrics}
                />
              ) : (
                <span style={{ fontSize: "12px" }}>Please Select Group First</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupCategoryTreeView;
